import { apiClient, makeServicePlugin, BaseModel } from '@/api'

class Account extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'Account'
  // Define default properties here
  static instanceDefaults() {
    return {
      name: "",
      email: "",
      phone: "",
      address: "",
      postal: "",
      vat: ""
    }
  }

  static setupInstance(data, { models }) {
    if (data.subscription) {
      data.subscription = new models.api.Subscription(data.subscription)
    }
    return data
  }
}

const servicePath = 'accounts'
const servicePlugin = makeServicePlugin({
  Model: Account,
  service: apiClient.service(servicePath),
  servicePath
})

// Setup the client-side Feathers hooks.
apiClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin